module.exports = __webpack_public_path__ + "50f06966e3f51be2fa7d03e9679000df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/dmo-with-color.svg
// module id = 3636
// module chunks = 6